<template>
    <div>
        <portal-navbar> </portal-navbar>

        <fade-transition :duration="200" origin="center top" mode="out-in">
            <router-view class="px-4 py-4"></router-view>
        </fade-transition>
    </div>
</template>

<script>
import PortalNavbar from './PortalNavbar'
import { FadeTransition } from 'vue2-transitions'

export default {
    components: {
        PortalNavbar,
        FadeTransition,
    },
}
</script>
